<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-row>
            <div class="col-6">
        <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                style="padding-left: 10px;margin-top: 0;padding-top: 0;"
                hide-details></v-text-field>
            </div>
        </v-row>
        <v-data-table
                :headers="headers"
                :items="transfers_envoyes"
                :search="search"
                :loading="!transfers_envoyes" loading-text="Chargement en cours..."
                sort-by="label"
                class="elevation-1">
            <template v-slot:item._file="{item}">
                <a :href="item._file">{{getFileOriginalName(item._file)}}</a>
            </template>
            <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <v-col cols="12" sm="12"
                                   md="12" class="text-lg-center" style="font-weight: bold;font-size: 18px">
                                DETAILS DU TRANSFERT
                            </v-col>
                        </v-card-title>

                        <v-card-text>

                            <v-row >
                                <v-col v-if="desc.receiver_user" cols="12" sm="6"
                                       md="6" >
                                    <span style="font-weight: bold">  Nom :</span>
                                    <span v-if="desc.receiver_user._first_name">
                                        {{desc.receiver_user._first_name}}
                                    </span>
                                    <span  v-else >
                                         ---
                                    </span>
                                </v-col>

                                <v-col  v-if="desc.receiver_user" cols="12" sm="6"
                                        md="6" >
                                    <span style="font-weight: bold">
                                        Prénom :
                                    </span>
                                    <span v-if="desc.receiver_user._last_name">
                                        {{desc.receiver_user._last_name}}
                                    </span>
                                    <span  v-else >
                                         ---
                                    </span>
                                </v-col>


                                <v-col v-if="desc.receiver_user" cols="12" sm="6"
                                       md="6" >
                                    <span style="font-weight: bold">
                                        Email :
                                    </span> {{desc.receiver_user._email}}

                                </v-col>
                                <v-col v-else cols="12" sm="6"
                                       md="6" style="font-weight: bold">
                                    Email : ---

                                </v-col>

                                <v-col  v-if="desc.x_currency" cols="12" sm="6"
                                       md="6">
                                    <span  style="font-weight: bold">
                                        Montant Envoyer :
                                    </span> {{desc._amount}} {{desc.x_currency._code_alpha}}
                                </v-col>
                                <v-col v-if="desc._received_amount && desc.wallet_currency" cols="12" sm="6"
                                       md="6" >
                                    <span style="font-weight: bold">
                                                                            Montant Reçu :
                                    </span>
                                    {{desc._received_amount}} {{desc.wallet_currency._code_alpha}}
                                </v-col>
                                <v-col v-if="desc._fees && desc.x_currency" cols="12" sm="6"
                                       md="6" >
                                    <span style="font-weight: bold">
                                        {{$t("recharges.fees")}} :
                                    </span> {{desc._fees}} {{desc.x_currency._code_alpha}}

                                </v-col>

                                <v-col  v-if="desc._received_amount && desc.wallet_currency && desc._fees" cols="12" sm="6"
                                       md="6">
                                    <span  style="font-weight: bold">
                                        {{$t("recharges.net_amount")}} :
                                    </span>  {{(parseFloat(desc._fees)+parseFloat(desc._amount))}} {{desc.x_currency._code_alpha}}
                                </v-col>
                                <v-col cols="12" sm="12"
                                       md="12" style="text-align: center" >
                                    <span style="font-weight: bold;">
                                         Motif :
                                    </span>
                                </v-col>
                                <v-col cols="12" sm="12"
                                       md="12" >
                                    {{desc._reason}}
                                </v-col>
                            </v-row>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click.prevent="close">{{$t('close')}}</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </template>
            <template v-slot:item.actions="{ item }">
                <div style="text-align:  right">
                    <v-menu
                            key="text"
                            rounded="b-xl">
                        <template v-slot:activator="{ attrs, on }">

                            <v-icon

                                    class="black--text "
                                    v-bind="attrs"
                                    v-on="on">mdi-dots-vertical</v-icon>

                        </template>
                        <v-list>
                            <v-list-item @click="showdescription(item)">
                                <v-list-item-icon>
                                    <v-icon  color="primary">mdi-eye</v-icon>

                                </v-list-item-icon>
                                <v-list-item-content>

                                    <v-list-item-title >
                                        Détails
                                    </v-list-item-title>
                                </v-list-item-content>

                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>

            </template>
          <template v-slot:item._created_at="{item}">
                        {{  getDate(item._created_at)}}
          </template>
            <template  v-slot:item._amount="{item}">
                <span v-if="item.x_currency">
                      {{item._amount}} {{item.x_currency._code_alpha}}
                </span>

          </template>
            <template v-slot:no-data>
                <span>{{$t('no_data')}}</span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import helpers from '../../../../mixins/helpers'


    export default {
        name: "TransfertEnvoyer",
        mixins:[helpers(this)],
        data () {
            return {
                submitting:false,
                valid:true,
                lazy:false,
                items: [],
                transfers_envoyes: [],
                errors:{},
                search: '',
                recep:'',
                desc:'',
                tabs: null,
                dialog: '',
                ratenow:1,
                walle:0,
                id:undefined,
                categorieHasChanged:false,
                headers: [
                    {text: 'Référence', value: '_reference'},
                    {text: this.$t('transfert.recepteur'), value: 'receiver_user._email'},
                    {text: this.$t('transfert.montant'), value: '_amount'},
                    {text: this.$t('date'), value: '_created_at'},
                    { text: '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _montant: '',
                    _recepteur: '',
                    _net: '',
                    _reason: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _montant: '',
                    _recepteur: '',
                    _reason: '',
                    _net: '',
                    _created_at: 0,
                    _id:''
                },
                recepteurRules: [
                    v => !!v || this.$t('transfert.requis_recepteur'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                reasonRules: [
                    v => !!v || this.$t('transfert.requis_reason'),
                ],
                montantRules: {
                    required: v => !!v || this.$t('transfert.requis_montant'),
                    loanMin: v => v >= 1000 || 'Veuillez entrer le montant minimum de transfert. Montant >=1000',
                    loanMaxMax: v => (parseFloat(v)*parseFloat(this.ratenow))/100+parseFloat(v) <= this.walle || `Votre solde est inférieur au  montant net du transfert.`,
                },
                rules: {
                    required: value => !!value ||  'Entrer l\'émail du receptuer',
                    min: v => v!==undefined && v.length >= 8 || this.$t('min_8_caracters'),
                    match: v => v == this.password || this.$t('password_mismatch'),
                    email: v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) ||  this.$t('invalid_email'),
                    tel: v => (v.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g)) ||  this.$t('invalid_phone'),
                    //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
                },
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('transfert.new_transfert') : this.$t('transfert.update_transfert')
            },
            ...mapState('users/',['users']),
            ...mapState('transfers/',['transfers']),
            ...mapState('marchands/',['marchand']),
            ...mapState('wallets/',['wallet']),
            ...mapState('transfers/',['recepteur']),


        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        mounted(){
            this.$store.dispatch('users/getUsers').then(response=>{
                window.console.log('users',response)

            });

            if (this.$store.getters.auth.role._code==='admin') {
                let datarec = {"type":'admin', "id":("?")};
                this.$store.dispatch('transfers/getTransfer',datarec).then(response => {
                    window.console.log('transfers', response)
                });

            }
            else{
                let datarec = {"type":'user', "id":(this.$store.getters.auth._id)};
                this.$store.dispatch('transfers/getTransfer',datarec).then(response => {
                    var transfers_envoye=[];
                    for (let i=0;i<response.data.transfers.length; i++) {
                        if(!response.data.transfers[i].sender_marchand){
                            if (response.data.transfers[i].sender_user._email===this.$store.getters.auth._email ) {
                                let transfers_env=response.data.transfers[i];
                                transfers_envoye.push(transfers_env);
                            }
                        }

                    }
                    console.log('transfers_envoyés',transfers_envoye)
                    this.transfers_envoyes=transfers_envoye;

                    window.console.log('transfers', response)
                });
            }

            this.$store.dispatch('marchands/getMarchandOne').then(response => {
                console.log('marchand',response)
            });

        },
        methods:{
            showdescription(vdes){
                if (vdes===undefined) {
                    this.desc = 'Vide';
                    this.dialog = true;
                }else{
                    this.desc = vdes;
                    this.dialog = true;
                }

            },
            close () {
                this.dialog = false;
            },
        },
    }
</script>

<style scoped>

</style>